import { createAction, props } from '@ngrx/store';

export const setActivePath = createAction(
  '[App state] Set Active Path',
  props<{ activePath: string }>()
);

export const showLoading = createAction('[App] Show Loading');
export const hideLoading = createAction('[App] Hide Loading');
